
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InsureDailyCompany',
  components: {},
  data() {
    return {
      formSearch: {
        outDangerUserName: '',
        outDangerIdCardNo: ''
      }
    }
  },
  created() {
    // this.initTableList()
  },
  watch: {},
  methods: {
    onSearch() {
      this.$emit('onSearch')
    },
    onReset() {
      this.formSearch = {
        userName: '',
        userID: ''
      }
      this.$emit('onReset')
    }
  }
})
